/**
 * Based on our svg2elements solution
 *
 * @see https://github.com/webflow/webflow/blob/dev/packages/untyped/svg2elements/lib/src/toElements.js
 * @see https://webflow.atlassian.net/browse/BUG-10935
 */
export const useSvgToElements = (props: any): any => {
  const {className, name, style = {}, ...rest} = props;

  return {
    'aria-hidden': true,
    'data-icon': name,
    className: 'bem-Svg' + (className ? ' ' + className : ''),
    focusable: false,
    style: {
      display: 'block',
      ...style,
    },
    ...rest,
  };
};
